module.exports = __webpack_public_path__ + "static/media/002yhkgl.c70251ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/002yhkgl.jpg
// module id = 626
// module chunks = 0 1